import React from 'react'
import { Section, SectionTitle, SimpleDataList, SimpleDataItem } from '../style'
import { CalendarClock, CalendarDays, Clock, FileText } from 'lucide-react'

const SimpleData = () => {
  return (
    <Section>
      <SectionTitle> <FileText size={20} /> Dados da OP </SectionTitle>
      <SimpleDataList>
        <SimpleDataItem><CalendarDays /> 20/06/2025</SimpleDataItem>
        <SimpleDataItem><Clock /> 10:00</SimpleDataItem>
      </SimpleDataList>
    </Section>
  )
}

export default SimpleData